// Leave enough room for a 24 px seek target clear of the trim handle.
export const MIN_SCENE_PREVIEW_WIDTH = 48;
export const MIN_SCENE_FRAME_WIDTH = 24;

type TimeRange = { startTime: number; endTime: number };

export type TimelineScenePreview = TimeRange & {
  intervalId: number;
  /** Source scene time, shared by every interval intersecting this scene. */
  sceneStartTime: number;
  /** Visible portion, used to keep controls and extraction within the viewport. */
  visibleStartTime: number;
  visibleEndTime: number;
};

/** Intersect source scenes with edited intervals and the viewport.
 * Keep the full interval intersection for accurate scene boundary placement. */
export function getVisibleScenePreviews({
  intervals,
  sceneMarkers,
  viewStart,
  viewEnd,
}: {
  intervals: Array<TimeRange & { id: number }>;
  sceneMarkers: TimeRange[];
  viewStart: number;
  viewEnd: number;
}): TimelineScenePreview[] {
  if (viewEnd <= viewStart) return [];

  return intervals.flatMap((interval) => {
    if (interval.endTime <= viewStart || interval.startTime >= viewEnd) return [];

    return sceneMarkers.flatMap((scene) => {
      const startTime = Math.max(scene.startTime, interval.startTime);
      const endTime = Math.min(scene.endTime, interval.endTime);
      const visibleStartTime = Math.max(startTime, viewStart);
      const visibleEndTime = Math.min(endTime, viewEnd);
      if (visibleEndTime <= visibleStartTime) return [];

      return [{
        intervalId: interval.id,
        sceneStartTime: scene.startTime,
        startTime,
        endTime,
        visibleStartTime,
        visibleEndTime,
      }];
    });
  });
}
